// **********************************************************
// Specifications Modal
// **********************************************************

attachEvent('[data-specifications-modal-trigger]', 'click', (ev) => {
  toggleModal(ev.target, true);
  ev.preventDefault();
});
